import { useState, useContext } from "react";
import {
  Button,
  Input,
  Box,
  HStack,
  InputGroup,
  InputLeftAddon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";
import toast from "react-hot-toast";

// Styles
import { layerStyle } from "theme/names";

// Utils
import { getToken } from "../../firebaseClient";
import { useSession } from "next-auth/react";
import { MainContext } from "context/mainContext";
import { getCreditBack, useCredit } from "controllers/subscription";
import { getAccount } from "utils/sessionHelper";

// Types
import { Carousel } from "types/carousel";
import { AiButton } from "components/common/AiButton/AiButton";
import { height } from "@mui/system";

interface ApiResponse {
  success: number;
  carousels?: Carousel[];
  error?: string;
}
const baseUrl = "https://us-central1-ez4cast.cloudfunctions.net";

const generateAIContent = async (input, session, useBestAi, type) => {
  const token = await getToken(session, "aiCarouselGenerator");
  const userDescription = getAccount(session)?.description;
  return await fetch(`${baseUrl}/linkedinCarousell-generateai`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      tokenuserid: session.user.uid,
    },
    body: JSON.stringify({
      input,
      type,
      description: userDescription,
      useBestAi,
      isInfluentLeader: true,
    }),
  });
};

const generationOptions = [
  { value: "article", label: "URL", placeholder: "https://website.com" },
  {
    value: "youtube",
    label: "YouTube",
    placeholder: "https://www.youtube.com/watch?v=4xr31ndea",
  },
  {
    value: "ai",
    label: "AI",
    placeholder: "What should your carousel be about?",
  },
];
const InputGenerator = ({
  setAppState,
  setselectedCarouselId,
}: {
  setAppState: React.Dispatch<React.SetStateAction<any>>;
  setselectedCarouselId: (id: string) => void;
}) => {
  const { data: session } = useSession() ?? {};
  const mainContext = useContext(MainContext);
  const [value, setValue] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string>(
    generationOptions[0].value
  );

  const handleGeneration = async () => {
    if (!value) {
      toast.error("Please enter some text to generate the carousel.");
      return;
    }
    setIsLoading(true);
    let useBestAi = await useCredit(
      session,
      mainContext,
      "creditsBestai",
      false
    );
    try {
      const res = await generateAIContent(
        value,
        session,
        useBestAi,
        selectedOption
      );

      let data: ApiResponse = await res.json();
      if (data.success === 1 && data.carousels) {
        setAppState({
          type: "RECREATE_CAROUSEL",
          payload: data.carousels,
        });
        setselectedCarouselId(data.carousels[0].id);
        setIsLoading(false);
      } else if (data.success === 0 && data.error) {
        toast.error(data.error);
      } else {
        throw new Error();
      }
    } catch (error) {
      getCreditBack(session, "creditsBestai");
      toast.error(
        "Something went wrong while generating the carousel. Please try again."
      );
    }
    setIsLoading(false);
  };
  return (
    <HStack p={{
      base: 6, md: 8
    }} mb={4} layerStyle={layerStyle["bg.border.rounded"]} flexWrap={["wrap", "wrap", "nowrap"]} justifyContent="center" gap={{
      base: 6, md: 4
    }}>
      <InputGroup position={"relative"} zIndex={9} size={{ base: "md", md: "lg" }}>
        <InputLeftAddon sx={{
          padding: "0 !important"
        }}>
          <Menu autoSelect={false} >
            <MenuButton as={Button} variant="ghost" rightIcon={<ChevronDownIcon />} w="7rem">
              {generationOptions.find(
                (option) => option.value === selectedOption
              )?.label}

            </MenuButton>
            <MenuList minW="7rem">
              {generationOptions.map((option) => (
                <MenuItem
                  key={option.value}
                  onClick={() => setSelectedOption(option.value)}
                >
                  {option.label}
                </MenuItem>
              ))}
            </MenuList>
          </Menu>
        </InputLeftAddon>
        <Input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={
            generationOptions.find((option) => option.value === selectedOption)
              ?.placeholder
          }
          sx={{
            borderRadius: "0 !important",
            borderTopRightRadius: "0.375rem !important",
            borderBottomRightRadius: "0.375rem !important",

          }}

        />
      </InputGroup>
      <Box>
        {/* <Button
          bg="linear-gradient(150deg, rgba(49,107,255,1) 0%, rgba(236,97,129,1) 100%)"
          color="white"
          _hover={{
            bg: "linear-gradient(90deg, rgba(49,107,255,1) 0%, rgba(236,97,129,1) 100%)",
          }}
          isLoading={isLoading}
          onClick={handleGeneration}
          size={{ base: "md", md: "lg" }}
        >
          ⚡️ Generate Carousel
        </Button> */}
        <AiButton
          isLoading={isLoading}
          onClick={handleGeneration}
          containerProps={{
            w: "200px",
            h: "48px"
          }}
          width="200px"
          height="48px"
        // size={{ base: "md", md: "lg" }}
        >Generate Carousel</AiButton>
      </Box>
    </HStack >
  );
};

export default InputGenerator;
